import { TenantLogoOrLottie } from "./tenant-logo-or-lottie";
import { TextFadeAnimation } from "./text-fade";

export const LoadingScreen = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen gap-5">
      <TenantLogoOrLottie />
      <TextFadeAnimation text="Loading things up — almost there!" />
    </div>
  );
};

export default LoadingScreen;
